class CopyCode extends HTMLElement {
  connectedCallback() {
    this.style.cursor = 'pointer';

    this.addEventListener('click', () => {
      const text = this.innerText.trim();

      navigator.clipboard.writeText(text).then(() => {
        this.showToast('Copied coupon code');
      }).catch(() => {
        this.showToast('Copied False');
      });
    });
  }

  showToast(message) {
    const toast = document.createElement('div');
    toast.className = 'code_popup';
    toast.innerText = message;

    document.body.appendChild(toast);

    requestAnimationFrame(()=>{
      toast.classList.add('show');
    });

    setTimeout(()=>{
      toast.classList.remove('show');
      setTimeout(()=>toast.remove(),300);
    },1500);
  }
}

customElements.define('copy-code', CopyCode);


  



 class InfoPopup extends HTMLElement{
  connectedCallback(){

    const btn = document.querySelector(".is_info_popup");
    const overlay = document.querySelector(".info-popup-overlay");
    const close = document.querySelector(".info-popup-close");

    btn.addEventListener("click",()=>{
      overlay.classList.add("active");
    });

    close.addEventListener("click",()=>{
      overlay.classList.remove("active");
    });

    overlay.addEventListener("click",(e)=>{
      if(e.target === overlay){
        overlay.classList.remove("active");
      }
    });

  }
}

customElements.define("info-popup", InfoPopup);